import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";

const RecoverAccount = () => {
  const user = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("جارى العمل على إعادة تفعيل حسابك . . .");
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setLoading(true);
      navigate("/");
    }
  }, [user, navigate]);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (token) {
      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/recover-account`, { token })
        .then(() => setStatus("تم إعادة تفعيل حسابك بنجاح. تستطيع الآن تسجيل الدخول"))
        .catch(() => setStatus("Invalid or expired token."));
    } else {
      setStatus("رابط إعادة تفعيل الحساب غير صحيح");
    }
  }, []);

  if (loading) return <p>loading ...</p>;

  return <p>{status}</p>;
};

export default RecoverAccount;
